(() => {
  'use strict';
  const script = document.currentScript;
  if (!script || script.dataset.themeRole !== 'main' || window.Shopify?.designMode || new URLSearchParams(location.search).has('preview_theme_id')) return;
  if (window.__ylAdsEnquiryBound) return;
  window.__ylAdsEnquiryBound = true;
  const tagId = 'AW-17545087960';
  const destinations = {
    whatsapp: tagId + '/_ZAUCMqd8Z0dENiXk65B',
    enquiry: tagId + '/aef-CM2d8Z0dENiXk65B'
  };
  const pendingKey = 'yl_ads_enquiry_pending_v1';
  const maxAge = 30 * 60 * 1000;
  let configured = false;
  let ownsTag = false;
  let lastWhatsApp = 0;
  const privacy = () => window.Shopify?.customerPrivacy;
  const allowed = () => {
    try {
      return privacy()?.marketingAllowed() === true && privacy()?.analyticsProcessingAllowed() === true && privacy()?.saleOfDataAllowed() === true;
    } catch (_) { return false; }
  };
  const removePending = () => {
    try { sessionStorage.removeItem(pendingKey); } catch (_) {}
  };
  const readPending = () => {
    try { return JSON.parse(sessionStorage.getItem(pendingKey)); } catch (_) { return null; }
  };
  const consent = () => ({
    ad_storage: allowed() ? 'granted' : 'denied',
    ad_user_data: allowed() ? 'granted' : 'denied',
    ad_personalization: 'denied',
    analytics_storage: privacy()?.analyticsProcessingAllowed() === true ? 'granted' : 'denied'
  });
  const setupTag = () => {
    if (!allowed()) return false;
    if (configured) return true;
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function () { window.dataLayer.push(arguments); };
    }
    const existing = document.querySelector('script[src*="googletagmanager.com/gtag/js"]');
    ownsTag = !existing;
    if (ownsTag) {
      window.gtag('consent', 'default', consent());
      window.gtag('js', new Date());
    }
    window.gtag('config', tagId, { send_page_view: false, allow_ad_personalization_signals: false });
    if (ownsTag) {
      const google = document.createElement('script');
      google.async = true;
      google.src = 'https://www.googletagmanager.com/gtag/js?id=' + tagId;
      document.head.appendChild(google);
    }
    configured = true;
    return true;
  };
  const send = (kind, transactionId) => {
    if (!setupTag()) return false;
    const params = { send_to: destinations[kind], value: 0, currency: 'AED' };
    if (transactionId) params.transaction_id = transactionId;
    window.gtag('event', 'conversion', params);
    return true;
  };
  const onSuccess = () => {
    if (!document.querySelector('#yl-enquiry .yl-visit__form-success')) return;
    const pending = readPending();
    if (!pending || typeof pending.id !== 'string' || !Number.isFinite(pending.at)) return;
    const age = Date.now() - pending.at;
    if (age < 0 || age > maxAge) { removePending(); return; }
    if (allowed() && send('enquiry', pending.id)) removePending();
  };
  const onConsent = () => {
    if (ownsTag && configured) window.gtag('consent', 'update', consent());
    if (!allowed()) { removePending(); return; }
    setupTag();
    onSuccess();
  };
  const recipient = url => {
    if (url.protocol !== 'https:') return '';
    if (url.hostname === 'wa.me') return url.pathname.replace(/^\/\+?/, '').replace(/\/$/, '');
    if (['api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname) && url.pathname.replace(/\/$/, '') === '/send') return (url.searchParams.get('phone') || '').replace(/^\+/, '');
    return '';
  };
  const onLink = event => {
    if (!event.isTrusted || event.defaultPrevented || !allowed()) return;
    if (event.type === 'click' && event.button !== 0) return;
    if (event.type === 'auxclick' && event.button !== 1) return;
    const link = event.target?.closest?.('a[href]');
    if (!link || link.hasAttribute('download')) return;
    let url;
    try { url = new URL(link.href); } catch (_) { return; }
    // Number comes from SHOP custom.contact_phone via layout data-whatsapp-digits (2026-11-01), not hard-coded.
    const waDigits = (script && script.dataset.whatsappDigits) || '';
    if (!waDigits || recipient(url) !== waDigits) return;
    const now = Date.now();
    if (now - lastWhatsApp < 2000) return;
    if (send('whatsapp')) lastWhatsApp = now;
  };
  window.addEventListener('click', onLink);
  window.addEventListener('auxclick', onLink);
  document.addEventListener('submit', event => {
    if (!event.isTrusted || event.defaultPrevented || event.target?.id !== 'yl-enquiry' || !allowed()) return;
    try {
      const id = crypto.randomUUID();
      sessionStorage.setItem(pendingKey, JSON.stringify({ id, at: Date.now() }));
    } catch (_) {}
  });
  document.addEventListener('visitorConsentCollected', onConsent);
  if (privacy()) onConsent();
  else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) onConsent();
    });
  }
})();
